<template>
  <v-content class="pa-12" style="background-color: #FAF5F2">
    <div v-if="isLoading === true">
      <h1>กำลังดึงข้อมูล...</h1>
    </div>
    <div v-else-if="history.length === 0">
      <h1>ไม่ได้มีการบันทึกประวัติสำหรับงานวิจัยนี้</h1>
    </div>
    <div v-else>
      <v-layout py-4 style="background-color: #3E7662;">
        <v-flex>
          <span style="color: white;font-size: 18px">ประวัติงานวิจัย: {{ researchName }}</span>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex>
          <v-divider
              style="background-color: #544A44;border-width: 2px"
          ></v-divider>
        </v-flex>
      </v-layout>
      <v-data-table
          :headers="header" :items="history"
      >
        <template v-slot:item.description="{ item }">
          <div v-if="!item.disabled">
          <a :href="'/view-research?logid='+item.id" target="_blank">
            <v-icon
                color="#3E7662"
            > visibility </v-icon>
          </a>
          </div>
<!--          <div v-html="item.diff">-->
<!--          </div>-->
        </template>
      </v-data-table>
    </div>

    <!-- Modal Edit Consider Result -->
    <template>
      <v-row justify="center">
        <v-dialog
            v-model="checkDialog"
            persistent
            width="800px"
            max-width="80%"
        >
          <v-card>
            <!-- Header -->
            <v-card-title class="mb-4">
              <span class="font-weight-medium font-weight-bold"
              >ข้อมูลการแก้ไข</span
              >
            </v-card-title>
            <v-card-text class="text-left">
              <p v-for="(val, key) in showDiff" v-bind:key="key">
                {{ key }} => {{ val ? val : '-' }}
              </p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                  style="font-weight: bold"
                  color="#3E7662"
                  text
                  @click="checkDialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-content>
</template>

<script>
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import FormTable from "../../components/table/FormTable";
import { mapState, mapActions } from "vuex";
import AuthService from "../../services/AuthService";

export default {
  components: {
    FormTable,
    Loading,
  },
  data: () => ({
    checkDialog: false,
    showDiff: '',
    researchName: '',
    history:[],
    header:[
      {
        text: "ผู้กระทำ",
        value: "actioner",
        align: "center",
        sortable: false,
        class: "header-data-table",
      },
      {
        text: "action",
        value: "action",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "ข้อมูลการแก้ไข",
        value: "description",
        align: "center",
        sortable: false,
        width: "20%",
      },
      {
        text: "action at",
        value: "action_at",
        align: "center",
        sortable: false,
        width: "20%",
      }
    ]
  }),
  created() {
    this.getResearchHistory(1);
  },
  methods: {
    getResearchHistory(page) {
      this.isLoading = true
      this.researchList = []
      let payload = {
        // page: page,
        researchID: this.$route.query.id
      }
      this.$store
          .dispatch("Research/getResearchHistory", payload)
          .then((res) => {
            console.log('then')
            this.researchName = res.researchName
            // this.history = res.researchLog
            res.researchLog.forEach((data) => {
              console.log(data)
              this.history.push(
                  {...data,
                    disabled: data.description === '-' || !['แก้ไขงานวิจัย', 'แก้ไขและส่งงานวิจัย', 'สร้างงานวิจัยใหม่'].includes(data.action) ||  !data.description.includes('"id"')
                  }
              );
            });
            this.isLoading = false;
            this.$forceUpdate()
            console.log('loading', this.isLoading)
          })
          .catch((e) => {
            console.log('e',e)
            this.isLoading = false;
            this.$forceUpdate()
          });
    },
    openModal(diff){
      // this.showDiff = diff
      // this.checkDialog = true
    }
  }
};
</script>

<style lang="scss">
table th + th {
  border-left: 1px solid #dddddd;
}
table td + td {
  border-left: 1px solid #dddddd;
}
.table {
  th.text-center.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}
.table {
  th.text-left.sortable {
    font-weight: bold;
    font-size: 16px;
  }
}
table thead tr th {
  text-align: center !important;
}
tbody tr td {
  color: #544a44;
}
table tbody tr td {
  text-align: left !important;
}
thead.v-data-table-header tr th {
  span {
    color: #000;
    font-size: 14px;
  }
}

.status-meeting:hover {
  text-decoration: underline;
}
.status-meeting-underline {
  text-decoration: underline;
}
.view-report {
  cursor: pointer;
}
.view-report:hover {
  color: #3e7662;
  font-weight: bold;
  text-decoration: underline;
}
</style>

